<div class="modal-header d-flex justify-content-center bg-light">
  <h4 class="modal-title text-center strong">{{ 'home.productHeader.SelectProducts' | cxTranslate }}<div class="modalsubheader">{{'tenders.wishto'| cxTranslate}}</div>
  </h4>
</div>
<div class="modal-body bg-light">
    <div *ngFor="let data of productsInfo.combinedTenders;let i=index">
    <label class="card mt-3 rounded">
      <div class="card-body" [ngClass]="{'bg-gray-200': data.checked}">
          <div  class="ml-5  d-flex line-height">
            <label class="mb-0">
              <input type="checkbox" [(ngModel)]="data.checked" disabled (change)="onCheckboxChange(data,$event)"/>
              <div class="small text-secondary">{{ 'home.headerLinks.material' | cxTranslate }} #{{i+1}}</div>
              <h5 class="strong">{{data.newName?data.newName:data.productName}}</h5>
              <div class="d-flex justify-content-between mt-2">
              <div class="row">
                <div class="col">
                  <div class="small text-secondary" *ngIf="productsInfo.commodityType=='CC'">{{ 'tenders.Quantity(DMT)' | cxTranslate }}({{data.displayQuantityUnitDesc}})</div>
                <div class="small text-secondary" *ngIf="productsInfo.commodityType=='IO'">{{ 'tenders.Quantity(DMT)' | cxTranslate }}({{data.displayQuantityUnitDesc}})</div>
                <div class="strong">{{data.quantity | number}}</div>
              </div>
                <div class="col">
                  <div class="small text-secondary del" *ngIf="(productsInfo.commodityType=='IO' ||productsInfo.commodityType=='CC') && productsInfo?.arrivalPeriod == 'true'">{{'tenders.ArrivalPeriod'| cxTranslate}}</div>
                  <div class="small text-secondary" *ngIf="((productsInfo.commodityType=='CC' || productsInfo.commodityType=='IO') && productsInfo?.arrivalPeriod == 'false')">{{'tenders.LoadPortLaycan'| cxTranslate}}</div>
                  <div class="small text-secondary" *ngIf="((productsInfo.commodityType=='CA') && productsInfo?.arrivalPeriod == 'false')">{{'tenders.schedule'| cxTranslate}}</div>
                  <div *ngIf="(productsInfo?.arrivalPeriod == 'false')" class=" small">{{data ?.laycanStartDate | date:"dd/MM/yyyy"}} - {{data ?.laycanEndDate | date:"dd/MM/yyyy"}}</div>
                  <div *ngIf="(productsInfo?.arrivalPeriod == 'true')" class=" small">{{productsInfo ?.arrivalStartDate | date:"dd/MM/yyyy"}} - {{productsInfo ?.arrivalEndDate | date:"dd/MM/yyyy"}}</div>
                </div>
              </div>
              </div>
            </label>
          </div>
          
        </div>
      </label>
    </div>
    <!-- <div class="card">
      <div class="card-body">
          <div  class="ml-5  d-flex line-height">
            <label class="" >
              <input type="checkbox" id="material1" /><div class="small text-secondary">Material #1</div>
              <div>Copper Concentrate Escondida</div>
              <div class="d-flex justify-content-between mt-3">
              <div class="row">
                <div class="col">
                <div class="small text-secondary">Quantity (DMT)</div>
                <div>10,000</div>
              </div>
                <div class="col">
                  <div class="small text-secondary">Delivery period</div>
                  <div class=" small">01/03/22 - 31/03/22</div>
                </div>
              </div>
              </div>
            </label>
          </div>
          
        </div>
      </div>
      <div class="mt-3">
      <div class="card">
        <div class="card-body">
            <div  class="ml-5  d-flex line-height">
              <label class="" >
                <input type="checkbox"/><div class="small text-secondary">Material #2</div>
                <div class="strong">Copper Concentrate Escondida</div>
                <div class="d-flex justify-content-between mt-3">
                <div class="row">
                  <div class="col">
                  <div class="small text-secondary">Quantity (DMT)</div>
                  <div class=" small">10,000</div>
                </div>
                  <div class="col">
                    <div class="small text-secondary">Delivery period</div>
                    <div class=" small">01/03/22 - 31/03/22</div>
                  </div>
                </div>
                </div>
              </label>
            </div>
            
          </div>
        </div>
  </div> -->
</div>

<div class="modal-footer bg-light" >
    <div class="w-100">
        <!-- <button class="btn btn-block btn-primary" type="submit" (click)="navigateToQuote(productInfo,quantitySelected)" data-dismiss="modal" [disabled]="startDate == null || disabledBtn || productInfo.priceValue =='' || productInfo.priceValue == 0 || productInfo.priceValue < productInfo.minPrice"> -->
            <button class="btn btn-block btn-primary btn-lg" id="material1"   type="submit" (click)="Openmodal()" >{{'tenders.Next'|cxTranslate}}</button>

    <button class="btn btn-block btn-lg btn-light" type="button"  (click)="ActiveModal.dismiss('close click');close()">Cancel</button>
  </div>
</div>

